/**
 * RBAC-3.1 — the roles list behind Settings → Roles & Permissions.
 *
 * ⚠️ THIS MODULE HOLDS NO RULES. What the rows mean is `lib/accountRoles.ts`; who may read them is
 * the database's (`20261101a9`, refuses anyone without roles.administer with 42501). The account
 * is the caller's current one, decided server-side; nothing here passes a tenant id.
 */

import { supabase } from '@/lib/supabaseClient';
import { ACCOUNT_ROLES_RPC, parseAccountRoles, type AccountRole } from '@/lib/accountRoles';

export async function fetchAccountRoles(): Promise<AccountRole[]> {
  const { data, error } = await supabase.rpc(ACCOUNT_ROLES_RPC);
  if (error) throw new Error(error.message);
  return parseAccountRoles(data);
}
